<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport">
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="91vh"
        minHeight="200px"
        [showColumnLines]="false"
        [showRowLines]="true"
        (onCellPrepared)="onCellPrepared($event)"
    >
        <dxo-sorting mode="none"></dxo-sorting>
        <dxo-filter-row [visible]="false"></dxo-filter-row>
        <dxo-header-filter [visible]="false"></dxo-header-filter>
        <dxo-search-panel [visible]="false"></dxo-search-panel>
        <dxo-group-panel [visible]="false"></dxo-group-panel>
        <dxo-paging [enabled]="false"></dxo-paging>

        <dxi-column caption="From Location" dataField="from_location"></dxi-column>
        <dxi-column caption="To Location" dataField="to_location"></dxi-column>
        <dxi-column caption="Master Origin" dataField="master_origin"></dxi-column>
        <dxi-column caption="Business Group" dataField="business_group"></dxi-column>
        <dxi-column caption="Fleet" dataField="fleet_id"></dxi-column>
        <dxi-column caption="No. of Cars" dataField="no_of_cars" dataType="number"></dxi-column>
        <dxi-column caption="Duration Days" dataField="duration"></dxi-column>
    </dx-data-grid>
</div>
